import { ThemeFamilies } from './types';
var getButton = function (colors) {
    var _a;
    return (_a = {},
        _a[ThemeFamilies.PRIMARY] = {
            main: colors.primary,
            light: colors.primaryHover,
            dark: colors.primaryPressed,
            text: colors.secondary,
            disabled: colors.surface4,
            disabledText: colors.disabled,
            selectedText: colors.white,
        },
        _a[ThemeFamilies.SECONDARY] = {
            main: colors.secondary,
            light: colors.secondaryHover,
            dark: colors.secondaryPressed,
            text: colors.primary,
            disabled: colors.surface4,
            disabledText: colors.disabled,
            selectedText: colors.white,
        },
        _a[ThemeFamilies.TERTIARY] = {
            main: colors.thirdary,
            light: colors.thirdaryHover,
            dark: colors.thirdaryPressed,
            text: colors.primary,
            disabled: colors.surface4,
            disabledText: colors.disabled,
            selectedText: colors.white,
        },
        _a[ThemeFamilies.ERROR] = {
            main: colors.error,
            light: colors.errorHover,
            dark: colors.errorPressed,
            text: colors.white,
            disabled: colors.surface4,
            disabledText: colors.disabled,
            selectedText: colors.white,
        },
        _a[ThemeFamilies.SUCCESS] = {
            main: colors.success,
            light: colors.successHover,
            dark: colors.successPressed,
            text: colors.white,
            disabled: colors.surface4,
            disabledText: colors.disabled,
            selectedText: colors.white,
        },
        _a[ThemeFamilies.WARNING] = {
            main: colors.warning,
            light: colors.warningHover,
            dark: colors.warningPressed,
            text: colors.white,
            disabled: colors.surface4,
            disabledText: colors.disabled,
            selectedText: colors.white,
        },
        _a[ThemeFamilies.INFO] = {
            main: colors.surfaceFamilies.selected,
            light: colors.surfaceFamilies.selectedHover,
            dark: colors.surfaceFamilies.selectedPressed,
            text: colors.primary,
            disabled: colors.surface4,
            disabledText: colors.disabled,
            selectedText: colors.white,
        },
        _a[ThemeFamilies.DECORATIVE_BLUE] = {
            main: colors.secondary,
            light: colors.secondaryHover,
            dark: colors.secondaryPressed,
            text: colors.primary,
            disabled: colors.surface4,
            disabledText: colors.disabled,
            selectedText: colors.white,
        },
        _a[ThemeFamilies.GREY] = {
            main: colors.surface1,
            light: colors.surfaceFamilies.selectedHover,
            dark: colors.disabled,
            text: colors.white,
            disabled: colors.surface4,
            disabledText: colors.disabled,
            selectedText: colors.white,
        },
        _a[ThemeFamilies.DEFAULT] = {
            main: colors.white,
            light: colors.decorative.primary,
            dark: colors.decorative.primaryPressed,
            text: colors.surface1,
            disabled: colors.surface4,
            disabledText: colors.disabled,
            selectedText: colors.white,
        },
        _a[ThemeFamilies.BORDERED_PRIMARY] = {
            main: colors.white,
            text: colors.surface1,
            dark: colors.primaryPressed,
            light: colors.primaryHover,
            disabledText: colors.disabled,
            disabled: colors.surface4,
            selectedText: colors.surface3,
        },
        _a[ThemeFamilies.CIRCLED_PRIMARY] = {
            main: colors.grey.grey70,
            text: colors.white,
            disabled: colors.disabled,
            dark: colors.grey.grey80,
            selectedText: colors.white,
        },
        _a);
};
export default getButton;
